import { useLayoutEffect, useState } from 'react';
import { Provider } from 'jotai';
import { makeStyles } from '@material-ui/styles';
import { MDSPanel } from '@marqvision/mds/core';
import { queryClient } from '~/index';
import { reportQueryKey } from '~/apis/customerRequest';
import { RequestDetail } from './Detail';
import { RequestList } from './List';
import { AddRequest } from './Add';

const useStyles = makeStyles({
  content: {
    height: '100%',
    transition: '0.3s',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    '&>div': {
      position: 'relative',
      margin: '0',
    },
  },
});

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const RequestPanel = (props: Props) => {
  const { isOpen, onClose } = props;
  const classes = useStyles();

  const [viewTarget, setViewTarget] = useState<'list' | 'add' | number>('list');
  const panelWidth = viewTarget === 'list' ? '600px' : '760px';

  const handleAddMode = () => {
    setViewTarget('add');
  };

  const handleListMode = () => {
    queryClient.invalidateQueries([reportQueryKey]);
    setViewTarget('list');
  };

  const handleViewDetail = (target: number) => {
    setViewTarget(target);
  };

  const handleClose =  () => {
    if (viewTarget === 'add') return;
    queryClient.invalidateQueries([reportQueryKey]);
    onClose();
  };

  useLayoutEffect(() => {
    if (!isOpen) return;
    setViewTarget('list');
  }, [isOpen]);

  return (
    <MDSPanel
      open={isOpen}
      onClose={handleClose}
      anchor="right"
    >
      <Provider>
        <div className={classes.content} style={{ width: panelWidth }}>
          {viewTarget === 'list' &&
            <RequestList onAddMode={handleAddMode} onViewDetail={handleViewDetail} onClose={handleClose} />}
          {viewTarget === 'add' && <AddRequest onListMode={handleListMode} />}
          {typeof viewTarget === 'number' &&
            <RequestDetail selectedId={viewTarget} onListMode={handleListMode} />}
        </div>
      </Provider>
    </MDSPanel>
  );
};